import Grid from '@material-ui/core/Grid';

import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';

import { IDENTITY_DIALOG } from '../../../redux/constants/dialogs';
import Gravatar from '../Gravatar';
import ReduxDialog from '../ReduxDialog';
import { name } from '../../../utils/helper';

const styles = {
  heading: {
    fontWeight: 'bold',
  },
};

const IdentityDialog = ({ identity, hideDialog }) => {
  const actions = [];

  return (
    <ReduxDialog
      name={IDENTITY_DIALOG}
      title={name(identity)}
      actions={actions}
      bodyStyle={styles.body}
      fullWidth
      maxWidth="sm"
    >
      <div style={{ padding: 10 }}>
        <Grid container spacing={8}>
          {identity.email ? <Grid item>
            <Gravatar email={identity.email} size={200}/>
          </Grid> : null}
          <Grid item xs>
            <Grid container spacing={8}>
              {identity.phone ? <Grid item xs={12}>
                <Typography variant="caption">Phone</Typography>
                <div>{identity.phone}</div>
              </Grid> : null}
              {identity.mobile ? <Grid item xs={12}>
                <Typography variant="caption">Mobile</Typography>
                <div>{identity.mobile}</div>
              </Grid> : null}
              {identity.email ? <Grid item xs={12}>
                <Typography variant="caption">Email</Typography>
                <a href={`mailto:${ identity.email}`}>{identity.email}</a>
              </Grid> : null}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </ReduxDialog>);
};

IdentityDialog.propTypes = {
  identity: PropTypes.object.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

export default IdentityDialog;



// WEBPACK FOOTER //
// ./src/components/Common/IdentityDialog/index.js